
<div class="card">
  <div class="card-body">
    <div class="row mb-3">
      <div class="col-sm-10">
        <p class="text-muted text-uppercase fw-semibold">Notifications</p>
      </div>
      <p-table  [lazy]="true" #dt (onLazyLoad)="loadNotifications($event)"  [value]="notifications"
        dataKey="id" [paginator]="true" [rowHover]="true" [rows]="10" [loading]="isLoading"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="[5,10,25,50]"
        responsiveLayout="scroll" [autoLayout]="true" [totalRecords]="totalRecords"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" paginatorDropdownAppendTo="body">
        <ng-template pTemplate="header">
          <tr>
            <th width="250px">Date</th>
            <th>Notification Type</th>
            <th>Details</th>
            <th>Status</th>
            <th width="250px" class="text-center">Dismiss Notification</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-notification>
          <tr>
            <td>{{ notification.createdOn | date:'MMMM d y,  h:mm a' }}</td>

            <td>
              <div [class.clickable-text]="isClickable(notification)"
                (click)="isClickable(notification) && navigateToTarget(notification)"
                class="fw-semibold" title="Click to view details">
                @if (isClickable(notification)) {
                  <i class="mdi mdi-link-variant me-1"></i>
                }
                {{ notification.displayText }}
              </div>
            </td>

            <td>{{ notification.commentText }}</td>
            <td >
              @if (!notification.read) {
                <span class="badge status-badge unread-status" (click)="markAsRead(notification.id)">
                  Unread
                  @if (markingIds.has(notification.id)) {
                    <i class="mdi mdi-loading mdi-spin"></i>
                  }
                </span>
              }

              @if (notification.read) {
                <span class="badge status-badge read-status" >
                  Read
                </span>
              }
            </td>

            <td class="text-center">
              <button class="btn btn-danger btn-sm dismiss-btn" (click)="dismissNotification(notification.id)">
                @if (submittingIds.has(notification.id)) {
                  <i class="mdi mdi-loading mdi-spin"></i>
                }

                @if (!submittingIds.has(notification.id)) {
                  <i class="mdi mdi-eye-off-outline"></i>
                }
              </button>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptyMessage">
          <tr>
            <td colspan="5" class="text-center">
              No notifications found.
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>